import { render, staticRenderFns } from "./Etf.vue?vue&type=template&id=6e06f4a0&scoped=true&"
import script from "./Etf.vue?vue&type=script&lang=js&"
export * from "./Etf.vue?vue&type=script&lang=js&"
import style0 from "./Etf.vue?vue&type=style&index=0&id=6e06f4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e06f4a0",
  null
  
)

export default component.exports